<template>
  <p class="text-lg leading-relaxed text-gray-700">
    <slot />
  </p>
</template>

<script setup>
// No props needed
</script>
